<template>
  <div>
    <!-- Conditionally render MainLayout based on the route's meta field -->
    <MainLayout v-if="$route.meta.requiresMainLayout">
      <router-view />
    </MainLayout>
    
    <!-- Render router-view directly for routes without MainLayout -->
    <router-view v-else />
  </div>
</template>

<script>
import MainLayout from './layouts/MainLayout.vue';

export default {
  name: 'App',
  components: {
    MainLayout,
  },
};
</script>
